﻿/// <reference path="../walkinManager.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />

declare var device;

module Meevo.Plugins.WalkinManager.AssignEmployee {
    import IWalkinAppointment = Meevo.Plugins.WalkinManager.IWalkinAppointment;
    import AppointFinalStateEnum = Meevo.Model.AppointFinalStateEnum;

    enum EUpdateType {
        save,
        checkout
    }

    class AssignmentModalController {
        static $inject = [
            '$scope',
            '$q',
            'item',
            '$mdDialog',
            'meevo.components.busy.BusyService',
            'meevo.plugins.walkinManager.addToWaitlist.employeeListService',
            'meevo.components.modal.ModalService',
            'Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService',
            '$rootScope',
            'meevo.plugins.walkinManager.WalkInSettingsService',
            'meevo.plugins.walkinManager.WalkinAppointmentService',
        ];
        public item: IWalkinAppointment;
        public allItems: boolean;
        protected $mdDialog: ng.material.IDialogService;
        public searchCriteria: any;
        public currentEmployee: any;

        constructor(
            protected $scope: ng.IScope,
            protected $q: ng.IQService,
            item: IWalkinAppointment,
            $mdDialog: ng.material.IDialogService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected employeeListService: Meevo.Plugins.WalkinManager.AddToWaitlist.IEmployeeList,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appointmentModal: Meevo.Plugins.AppointmentBook.Services.AppointmentBookModalService,
            protected $rootScope: ng.IRootScopeService,
            protected settingsService: Meevo.Plugins.WalkinManager.IWalkInSettingsService,
            private walkinAppointmentService: Meevo.Plugins.WalkinManager.IWalkinAppointmentService,
        ) {
            this.$mdDialog = $mdDialog;

            this.busyService.start();
            this.loadData();
        }

        public save(): void {
            this.busyService.start();

            this.updateAppointment(EUpdateType.save, false)
                .then((res) => {
                    this.busyService.stop();
                    if (res.isWarning) {
                        this.showError(res, (messageResult) => {
                            if (messageResult === Meevo.Model.MessageBoxButtonResult.Yes) {
                                this.busyService.start();
                                this.updateAppointment(EUpdateType.save, true)
                                    .then(() => {
                                        this.busyService.stop();
                                        this.$mdDialog.hide();
                                    });
                            } else {
                                this.$mdDialog.hide();
                            }
                        });

                        return;
                    }

                    this.$mdDialog.hide();

                    return;
                });
        }

        public checkout(): void {
            this.busyService.start();

            this.updateAppointment(EUpdateType.checkout, false)
                .then((res) => {
                    let deferred = this.$q.defer();

                    if (res.isWarning) {
                        this.busyService.stop();
                        this.showError(res, (messageResult) => {
                            if (messageResult === Meevo.Model.MessageBoxButtonResult.Yes) {
                                this.busyService.start();
                                this.updateAppointment(EUpdateType.save, true)
                                    .then((res) => deferred.resolve(res));
                            } else {
                                deferred.resolve(null);
                            }
                        });
                    } else {
                        deferred.resolve(res);
                    }

                    return deferred.promise;
                })
                .then((res: any) => {
                    this.busyService.stop();
                    if (res !== null) {
                        let params = this.allItems ? {
                            action: Meevo.Components.Common.Messages.MANUAL_SALE_LINES,
                            services: res.items.filter((item) => item.appointmentServiceFinalState === AppointFinalStateEnum.None)
                                .map((item) => ({
                                    serviceId: item.serviceId,
                                    appointmentServiceId: item.appointServiceId
                                })),
                            clientId: this.item.clientId,
                            employeeId: this.currentEmployee ? this.currentEmployee.id : undefined,
                            selectSection: null,
                        } : {
                            action: Meevo.Components.Common.Messages.MANUAL_SALE_LINE,
                            appointmentServiceId: this.item.appointServiceId,
                            serviceId: this.item.serviceId,
                            clientId: this.item.clientId,
                            employeeId: this.currentEmployee ? this.currentEmployee.id : undefined,
                            selectSection: null,
                        };

                        if (device.tablet() || device.mobile()) {
                            params.selectSection = Meevo.Plugins.Register.RegisterSectionTypeEnum.Ticket;
                        }
                        this.goToRegister(params);
                    }
                    this.$mdDialog.hide();
                });
        }

        public closeModal(): void {
            this.$mdDialog.cancel();
        }

        private loadData(): void {
            this.walkinAppointmentService.getAppointment(this.item.id)
                .then((data: IWalkinAppointment) => {
                    this.item = data;

                    this.searchCriteria = {
                        serviceId: this.item.serviceId,
                        eligibleForWalkinManager: true,
                        view: Meevo.Model.EmployeeSearchView.WithEmployeeServicePricing
                    };
                    this.employeeListService.searchCriteria = this.searchCriteria;

                    return this.employeeListService.fetchEmployees(this.settingsService.settings.showOnlyClockedInEmployees);
                })
                .then(() => {
                    if (this.item['employeeGenderSearchEnum'] === Meevo.Model.EmployeeGenderSearchEnum.SpecificEmployee ||
                        this.item.employeeId !== Guid.empty) {
                        if (this.settingsService.settings.showOnlyClockedInEmployees &&
                            this.item['employeeGenderSearchEnum'] !== Meevo.Model.EmployeeGenderSearchEnum.SpecificEmployee) {
                            this.currentEmployee = this.employeeListService.employees[0];
                        } else {
                            this.currentEmployee = _.find(this.employeeListService.employees, (employee) => {
                                return employee.id === this.item.employeeId.toString();
                            });
                        }
                    } else {
                        this.currentEmployee = null;
                    }
                })
                .finally(() => this.busyService.stop());
        }

        private goToRegister(params: object): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'register',
                stateParams: params
            });
        }

        private showError(response, callback) {
            const errors = [];
            if (!!response.responseStatus && response.responseStatus.errors.length !== 0) {
                errors.push(...response.responseStatus.errors);
            }

            if (!!response.responseStatus && response.responseStatus.errorCode === 'Conflict' && response.responseStatus.message) {
                errors.push({ message: response.responseStatus.message });
            }


            if (errors.length !== 0) {
                this.appointmentModal.showMessages(errors, 'HEADER_APPOINTMENT_WARNING', {
                    buttonsType: Meevo.Model.ButtonTypeEnum.YesNo,
                    callback
                });
            }
        }

        private updateAppointment(updateType: EUpdateType, suppressWarnings: boolean): ng.IPromise<any> {
            if (this.allItems) {
                let requestData = {
                    AppointmentDate: moment(this.item.startDateTime).toDate().toDateString(),
                    PatchLocalAppointmentsOnly: true,
                    TransitionState: Meevo.Model.AppointStateEnum.CheckedIn,
                    employeeId: this.currentEmployee.id,
                    suppressWarnings,
                };

                if (updateType === EUpdateType.checkout) {
                    requestData['WalkinStatus'] = Meevo.Model.WalkInStatusEnum.CheckedOut;
                }

                return this.walkinAppointmentService.updateAllAppointmentServiceByClientId(this.item.clientId.toString(), requestData);
            } else {
                let requestData = {
                    entityVersion: this.item.entityVersion,
                    employeeId: this.currentEmployee.id,
                    transitionStateEnum: Meevo.Model.AppointStateEnum.Booked,
                    suppressWarnings,
                };

                if (updateType === EUpdateType.checkout) {
                    requestData['WalkinStatus'] = Meevo.Model.WalkInStatusEnum.CheckedOut;
                }

                return this.walkinAppointmentService.updateOneAppointmentServiceByAppointmentId(this.item.id, {model: requestData});
            }

        }
    }

    angular.module('meevo.plugins.walkinManager')
        .controller('meevo.plugins.walkinManager.assignEmployee.AssignmentModalController', AssignmentModalController);
}
